export const ArrowUpRight = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M1.99984 21.6986L21.7988 1.89966" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.99992 1.89949H21.7989V21.6985" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
